<template>
  <q-card flat>
    <q-card-section v-if="!unit" class="text-bold">
      <div>
        <div>
          Concessions History<template v-if="propertyName"> for {{ propertyName }}</template>
        </div>
        <div class="text-caption" :class="$q.dark.isActive ? 'text-grey-5' : 'text-grey-7'">
          Specials History<template v-if="propertyName"> for {{ propertyName }}</template
          >, based on the selected date range of your report.
        </div>
      </div>
    </q-card-section>
    <concessions-table
      :concessions="concessionsHistory"
      :date-range="dateRange"
      :unit-level="Boolean(unit)"
    />
  </q-card>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { Availability, AvailabilityPeriod, PropertyDetailsResponse } from 'common'
import ConcessionsTable from '@/components/PropertyReports/ConcessionsTable.vue'

export default {
  name: 'ConcessionsCard',
  components: { ConcessionsTable },
  props: {
    property: {
      type: Object as PropType<PropertyDetailsResponse>,
      required: true
    },
    unit: {
      type: Object as PropType<Availability>,
      default: null
    },
    period: {
      type: Object as PropType<AvailabilityPeriod>,
      default: null
    },
    dateRange: {
      type: Object as PropType<{ from: Date; to: Date }>,
      default: null
    }
  },
  computed: {
    propertyName() {
      return this.property.building_name || this.property.street_address || ''
    },
    concessionsHistory() {
      let concessionsHistory = this.property.concessions_history || []
      if (this.unit && this.period) {
        const historyDates = this.unit.history
          .filter((_) => _.period_id === this.period.period_id)
          .flatMap((_) => [_.from_date, _.to_date])
        const minDate = historyDates.reduce((min, c) => (c < min ? c : min))
        const maxDate = historyDates.reduce((max, c) => (c > max ? c : max))
        concessionsHistory = concessionsHistory.filter((_) => {
          return !(maxDate < _.from_date || minDate > _.to_date)
        })
      }

      // Sort concessions with the newest first
      concessionsHistory.sort((a, b) => new Date(b.from_date) - new Date(a.from_date))

      return concessionsHistory.map((c) => ({ prop: this.property, concession: c }))
    }
  }
}
</script>
